const contact = {
  // page.tsx JSON-LD & breadcrumb
  'contact.jsonld.breadcrumb1': 'Home',
  'contact.jsonld.breadcrumb2': 'Contact',
  'contact.jsonld.orgName': 'The Japan Butler Academy',
  'contact.jsonld.parentOrg': 'The All Japan Butler Association',
  'contact.jsonld.addressLocality': '2-7-4 Aomi, Koto-ku, Tokyo',
  'contact.page.homeLink': 'Home',
  'contact.page.currentPage': 'Contact',
  'contact.page.lastUpdated': 'Last updated: 13 June 2026',
  'contact.page.backToTop': 'Back to top',

  // HeroSection
  'contact.hero.homeLink': 'Home',
  'contact.hero.currentPage': 'Contact',
  'contact.hero.title': 'Contact',
  'contact.hero.titleEn': 'CONTACT',
  'contact.hero.lead': 'Please use the form below for any questions or enquiries. A member of our team will reply within two business days.',
  'contact.hero.imgAlt': 'A butler standing attentively, ready to receive an enquiry',

  // InquiryGuideCards
  'contact.guides.label': 'TOPICS',
  'contact.guides.title': 'Find the Right Channel',
  'contact.guides.subtitleEn': 'Choose Your Inquiry Topic',
  'contact.guides.lead': 'Depending on the nature of your enquiry, one of our dedicated channels may serve you more efficiently. Please select the option that best matches your needs.',
  'contact.guides.0.title': 'Request a Brochure',
  'contact.guides.0.titleEn': 'Brochure Request',
  'contact.guides.0.description': 'Download or receive a free printed brochure covering our courses and the academy\'s educational philosophy.',
  'contact.guides.0.linkLabel': 'Request Your Free Brochure',
  'contact.guides.1.title': 'Discuss a Course',
  'contact.guides.1.titleEn': 'Course Consultation',
  'contact.guides.1.description': 'Our experienced staff will guide you to the course that best matches your goals and background — free of charge.',
  'contact.guides.1.linkLabel': 'Book a Free Consultation',
  'contact.guides.2.title': 'Frequently Asked Questions',
  'contact.guides.2.titleEn': 'FAQ',
  'contact.guides.2.description': 'Browse our answers to common questions about enrolment, curriculum, and fees before getting in touch.',
  'contact.guides.2.linkLabel': 'View FAQs',
  'contact.guides.3.title': 'Corporate Training',
  'contact.guides.3.titleEn': 'Corporate Training',
  'contact.guides.3.description': 'For enquiries about our corporate hospitality training programmes, please visit our dedicated corporate page.',
  'contact.guides.3.linkLabel': 'View Corporate Training',

  // ContactForm
  'contact.form.label': 'INQUIRY FORM',
  'contact.form.title': 'Enquiry Form',
  'contact.form.subtitleEn': 'Contact Form',
  'contact.form.lead': 'Please complete the form below and submit your enquiry.',
  'contact.form.required': 'Required',
  'contact.form.optional': 'Optional',
  'contact.form.altContact': 'You may also contact us by telephone',
  'contact.form.altOr': 'or by email',
  'contact.form.altAccept': '.',
  'contact.form.name': 'Full Name',
  'contact.form.namePlaceholder': 'e.g. Taro Shitsuji',
  'contact.form.nameError': 'Full name is required',
  'contact.form.furigana': 'Furigana (reading)',
  'contact.form.furiganaPlaceholder': 'e.g. shitsuji taro',
  'contact.form.furiganaError': 'Furigana is required',
  'contact.form.email': 'Email Address',
  'contact.form.emailPlaceholder': 'e.g. taro@example.com',
  'contact.form.emailError': 'Email address is required',
  'contact.form.emailInvalidError': 'Please enter a valid email address',
  'contact.form.phone': 'Phone Number',
  'contact.form.phonePlaceholder': 'e.g. 090-1234-5678',
  'contact.form.category': 'Enquiry Type',
  'contact.form.categoryPlaceholder': 'Please select',
  'contact.form.categoryError': 'Please select an enquiry type',
  'contact.form.content': 'Your Message',
  'contact.form.contentPlaceholder': 'Please describe your question or enquiry (max. 500 characters)',
  'contact.form.contentError': 'Message is required',
  'contact.form.contentLengthError': 'Please keep your message to 500 characters or fewer',
  'contact.form.privacy': 'Privacy Policy',
  'contact.form.privacyAgree': 'I agree to the',
  'contact.form.privacyError': 'You must agree to the Privacy Policy to proceed',
  'contact.form.submit': 'Submit Enquiry',
  'contact.form.cat.course': 'Course Enquiry',
  'contact.form.cat.pricing': 'Pricing',
  'contact.form.cat.admission': 'Admissions',
  'contact.form.cat.seminar': 'Taster Session',
  'contact.form.cat.corporate': 'Corporate Training',
  'contact.form.cat.other': 'Other',

  // PostSubmitGuide
  'contact.post.label': 'AFTER SUBMISSION',
  'contact.post.title': 'What Happens Next',
  'contact.post.subtitleEn': 'What Happens Next',
  'contact.post.lead': 'After you submit your enquiry, a member of our team will reply within two business days and address your questions personally.',
  'contact.post.step1.title': 'Automatic Confirmation Email',
  'contact.post.step1.desc': 'An automated acknowledgement will be sent to the email address you provided. Please keep it as a record of your submission.',
  'contact.post.step2.title': 'Personal Reply from Our Team',
  'contact.post.step2.desc': 'Once we have reviewed your enquiry, a team member will reply within two business days with answers and any additional information you may need.',
  'contact.post.step3.title': 'Ongoing Support if Required',
  'contact.post.step3.desc': 'Depending on your enquiry, we may follow up with further information such as a free consultation, brochure, or taster session.',

  // ContactInfo
  'contact.info.label': 'CONTACT INFORMATION',
  'contact.info.title': 'Phone & Email Enquiries',
  'contact.info.subtitleEn': 'Phone & Email',
  'contact.info.lead': 'You are also welcome to contact us by telephone or email. We look forward to hearing from you.',
  'contact.info.phone': 'Telephone',
  'contact.info.phoneHours': 'Weekdays 10:00–17:00 JST',
  'contact.info.email': 'Email',
  'contact.info.emailReply': 'Reply within 2 business days',
  'contact.info.address': 'Address',
  'contact.info.addressText': '2-7-4 Aomi, Koto-ku\nTokyo 135-0064, Japan\n(Odaiba)',
  'contact.info.accessLink': 'Getting Here',

  // FAQSection
  'contact.faq.label': 'FAQ',
  'contact.faq.title': 'Frequently Asked Questions',
  'contact.faq.subtitleEn': 'Frequently Asked Questions',
  'contact.faq.footer': 'If your question is not answered above, please use the enquiry form — we are happy to help.',
  'contact.faq.0.q': 'Can I contact you by telephone?',
  'contact.faq.0.a': 'Yes. Please call 03-6824-4086 (weekdays 10:00–17:00 JST). You are also welcome to reach us by form or email.',
  'contact.faq.1.q': 'How soon will I receive a reply?',
  'contact.faq.1.a': 'We reply within two business days.',
  'contact.faq.2.q': 'Can I enquire about corporate training here?',
  'contact.faq.2.a': 'Yes, although our Corporate Training page has a dedicated enquiry form that will reach the right team more directly.',

  // RelatedPages
  'contact.related.label': 'LEARN MORE',
  'contact.related.title': 'Related Pages',
  'contact.related.subtitleEn': 'Explore Further',
  'contact.related.viewMore': 'Learn More',
  'contact.related.0.title': 'FAQ',
  'contact.related.0.description': 'Answers to common questions about enrolment',
  'contact.related.1.title': 'Request a Brochure',
  'contact.related.1.description': 'Free brochure by email or post',
  'contact.related.2.title': 'Book a Consultation',
  'contact.related.2.description': 'Free — also available online',
  'contact.related.3.title': 'Corporate Training',
  'contact.related.3.description': 'Hospitality training for businesses',
};

export default contact;
